export const Hand = (props) => {
  const { size = 26, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} viewBox='0 0 27 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M14.543 14.3878L9.0379 7.91145C8.50164 7.28057 8.57842 6.33333 9.2093 5.79706V5.79706C9.84017 5.2608 10.7874 5.33758 11.3237 5.96846L16.8288 12.4448'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.3315 9.43526C9.79523 8.80438 8.84799 8.72759 8.21711 9.26386V9.26386C7.58623 9.80012 7.50945 10.7474 8.04571 11.3782L12.2555 16.3308'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.6179 7.49264C12.0816 6.86177 12.1584 5.91452 12.7893 5.37826C13.4202 4.842 14.3674 4.91878 14.9037 5.54966L18.4658 9.74026L20.4088 12.026L20.626 9.34641C20.6954 8.49079 21.4451 7.85349 22.3008 7.92285C23.0394 7.98273 23.6328 8.55581 23.7186 9.29135L24.4546 15.5798C24.6875 17.5723 23.9101 19.5496 22.3816 20.8488L21.0185 22.0074C18.4935 24.1538 14.7074 23.8469 12.561 21.3218L9.3227 17.5122L7.05588 14.8455C6.51962 14.2146 6.5964 13.2673 7.22728 12.7311C7.85815 12.1948 8.8054 12.2716 9.34166 12.9025'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M17.2695 3.4209C18.2038 3.38325 19.2654 4.52556 19.3018 5.4297' stroke='currentColor' strokeLinecap='round' />
        <path d='M5.01562 18.0869C4.08139 18.1246 3.0198 16.9823 2.98336 16.0781' stroke='currentColor' strokeLinecap='round' />
        <path d='M17.7188 1.24805C19.1411 1.03227 21.0249 3.0398 21.2848 4.75284' stroke='currentColor' strokeLinecap='round' />
        <path d='M4.56641 20.2598C3.14403 20.4755 1.26027 18.468 1.0004 16.755' stroke='currentColor' strokeLinecap='round' />
      </svg>
    </span>
  );
};
